import React, { useState } from 'react';
import InputForm from '../../InputT';
import SearInputM from '../../SearchModal';
import RadioBox from '../../Radiox';
import ParamsPicklist from '../../../Types/ParamsPicklist';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography, Divider } from '@mui/material';
import type { ColumnsType } from 'antd/es/table';
import { Card, Input, Modal, Radio, Table, Row, Col } from 'antd';
import { Form } from 'antd';
import FormImage from '../../FormImage';
import axios from 'axios';
import SweetAlert from 'sweetalert2';
import FilePresentIcon from '@mui/icons-material/FilePresent';
import { useAuthHeader, useAuthUser } from '../../../Services/Auth/sessionAuth';
import { FileTextOutlined, MoneyCollectOutlined, PhoneOutlined, PictureOutlined, UserOutlined, IdcardOutlined, HomeOutlined, CalendarOutlined } from '@ant-design/icons';
import ReformatDate from '../../../Functions/Traitement/ReformatDate';
import SearchInput from '../../SearchInput';
import { Crypter } from '../../../Functions/Security/Crypter';
import Link from '../../../Data/Data.json';
import DataProcurationClient from '../../../Types/DataProcurationClient';
import Utilisateur from '../../../Models/Utilisateur';
import { Grid } from '@mui/material';


interface DataType {
  key: React.Key;
  name: string;
  age: number;
  address: string;
}

const columns: ColumnsType<DataType> = [
  {
    title: 'Nom',
    width: 100,
    dataIndex: 'name',
    key: 'name',
    fixed: 'left',
  },
  {
    title: 'Prenom',
    width: 100,
    dataIndex: 'age',
    key: 'age',
    fixed: 'left',
  },

  {
    title: 'Tel',
    dataIndex: 'address',
    key: '2',
    width: 150,
  }]





const Tab1 = (props: { etatG?: boolean, form?: any, data: DataProcurationClient[], Consult: Function }) => {

  const [componentDisabled, setComponentDisabled] = useState<boolean>(true);
  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()));

  const [idrelation, setidrelation] = useState<boolean>(true);
  const [titre, settitre] = useState<boolean>(true);
  const [Sexe, setsexe] = useState<boolean>(true);
  const [nomrel, setnomrel] = useState<boolean>(true);
  const [Prenom, setPrenom] = useState<boolean>(true);
  const [DateNaiss, setDateNaiss] = useState<boolean>(true);
  const [PieceIdebtite, setPieceIdebtite] = useState<boolean>(true);
  const [Adresse, setAdresse] = useState<boolean>(true);
  const [Lieu, setLieu] = useState<boolean>(true);
  const [Expire, setExpire] = useState<boolean>(true);
  const [Tel, setTel] = useState<boolean>(true);
  const [FormR, SetFormR] = useState<boolean>(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewOpenM1, setPreviewOpenM1] = useState(false);
  const [previewImage, setPreviewImage] = useState<any>('');
  const [previewTitle, setPreviewTitle] = useState('');
  const [SearchR, SetSearchR] = useState<string>("");
  const [Reference, setReference] = useState<boolean>(false);


  const authHeader = useAuthHeader();

  //Initialisation des parametres de recherche
let searchClient: ParamsPicklist = { CodeAgence: user.codage, Table: "CLIENT", Colonne1: "NUMCLI", Colonne2: "NOMCLI", Colagence: 'CODAGE',  Choix: 22 }
let searchClient2: ParamsPicklist = { CodeAgence: user.codage, Table: "CLIENT", Colonne1: "NUMCLI", Colonne2: "NOMCLI", Colagence: 'CODAGE',  Choix: 22 }
let searchTitre: ParamsPicklist = { CodeAgence: 'TITRESCLIENT', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: 'RUBRIQ', Choix: 22 }
let searchFiliation: ParamsPicklist = { CodeAgence: 'FILIA', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: "RUBRIQ", Choix: 22 }

let informationclient = {

  SearchClient: {
    Titre: "recherchce client",
    label: "Indice client",
    name: "IdClient", params: searchClient
  },
  Searchrelation: {
    Titre: "Recherche procuration client",
    label: "Indice  procuration",
    name: "Refprocur", params: searchClient
  },
  SearchFiliation: {
    Titre: "Recherche Filiation",
    label: "Filiation",
    name: "filiation", params: searchFiliation
  },
  SearchTitre: {
    Titre: "search Titre Relation",
    label: "Titre",
    name: "titre", params: searchTitre
  },
  RadioSexe: {
    label: "Genre",
    LibValue1: "M",
    LibValue2: "F",
    name: "sexe"
  },
  Inputplafond:
  {
    label: 'Plafond retrait',
    name: "Plafond"
    //suspend  
  },
  InputNom:
  {
    label: 'Nom',
    name: "nom"
    //suspend  
  },
  InputPrenom:
  {
    label: 'Prénom',
    name: "prenom"
  },
  InputDateNaiss:
  {
    label: 'Date naissance',
    name: "dateNais"
  },
  InputPieceIdebtite:
  {
    label: 'Pièce Identité',
    name: "cni"
  },
  InputAdresse: {
    label: "Adresse",
    name: "adresProcur"
  },
  InputLieu: {
    label: "Lieu naissance",
    name: "lieuNais"
  },
  InputExpire: {
    label: "Expire le",
    name: "datExpirCni"
  },
  InputTel: {
    label: "Téléphone",
    name: "TelProcur"
  },

  InputEtabl: {
    label: "Etablie le",
    name: "datProcur"
  },
  InputIdp: {
    label: "Reférence procuration",
    name: "IdProcur"
  },
  InputAut: {
    label: "Autorité compétente",
    name: "autorite"
  },
  InputExpireP: {
    label: "Expire Le",
    name: "DatExpirProcur"
  },
  InputEntrv: {
    label: "Entrée en vigeur le",
    name: "datDebut"
  },
  InputPrf: {
    label: "Prend fin le",
    name: "DatFin"
  },
}


  const columns: ColumnsType<DataProcurationClient> = [
    {
      title: 'Reférence',
      dataIndex: 'CODEREL',
      ellipsis: true,
      width: 150,
    },
    {
      title: 'Id Client',
      dataIndex: 'idclient',
      ellipsis: true,
      width: 100,
    },
    {
      title: 'Nom',
      dataIndex: 'Nom',
      ellipsis: true,
      width: 100,
    },
    {
      title: 'Prenom',
      dataIndex: 'Prenom',
      ellipsis: true,
      width: 100,
    },
    {
      title: 'Tel',
      dataIndex: 'Tel',
      ellipsis: true,
      width: 100,
    },
    {
      title: 'ville',
      dataIndex: 'ville',
      ellipsis: true,
      width: 100,
    },
    {
      title: 'Date debut',
      dataIndex: 'DateDebut',
      ellipsis: true,
      width: 100,
    },
    {
      title: 'Date fin',
      dataIndex: 'DateFin',
      ellipsis: true,
      width: 100,
    },
    {
      title: 'Plafond ',
      dataIndex: 'plafond',
      ellipsis: true,
      width: 100,
    },
    {
      title: 'Filiation',
      dataIndex: 'filiation',
      ellipsis: true,
      width: 100,
    },
    {
      title: 'Photo ',
      dataIndex: 'photo',
      ellipsis: true,
      width: 100,
      render: (text: any, record: any) => (
        <span>
          <img
            onClick={e => { setPreviewImage(record.RelObject.photo); setPreviewTitle("Preview Image"); setPreviewOpenM1(true); }}
            style={{ height: 50, width: 50 }}
            src={record.RelObject.photo}
          ></img>
        </span>)
    },
    {
      title: 'Signature',
      ellipsis: true,
      width: 100,
      render: (text: any, record: any) => (
        <span>
          <img
            onClick={e => { setPreviewImage(record.RelObject.signature); setPreviewTitle("Preview Image"); setPreviewOpenM1(true); }}
            style={{ height: 50, width: 50 }}
            src={record.RelObject.signature}
          ></img>
        </span>)
    },
    {
      title: 'PieceJ1 ',
      ellipsis: true,
      width: 100,
      render: (text: any, record: any) => (
        record.RelObject.Piecej1 && record.RelObject.Piecej1 !== "" ? <Button disabled={false} onClick={e => { setPreviewImage(record.RelObject.Piecej1); setPreviewTitle("View Document"); setPreviewOpen(true); }}>
          <><FilePresentIcon /></>
        </Button> : ''
      )
    },
    {
      title: 'PieceJ2 ',
      ellipsis: true,
      width: 100,
      render: (text: any, record: any) => (
        record.RelObject.Piecej2 && record.RelObject.Piecej2 !== "" ? <Button disabled={false} onClick={e => { setPreviewImage(record.RelObject.Piecej2); setPreviewTitle("View Document"); setPreviewOpen(true); }}>
          <><FilePresentIcon /></>
        </Button> : ''
      )
    },
    {
      title: 'Date Creation',
      dataIndex: 'Datecre',
      ellipsis: true,
      width: 100,
    },
    {
      title: "",
      dataIndex: 'RelObject',
      align: 'center',
      width: 1
    }
  ]

  const StartConsulte = async () => {
    let data = Crypter.encrypt(props.form.getFieldValue("idrel"));
    // let clearNumcli = props.form.getFieldValue("CODREL");
    if (data.length != 0) {

      // props.form.resetFields();
      // props.form.setFieldValue("codrel", clearNumcli);
      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Link.ApiUrl.GetClient,
        headers: {
          'CypherNumcli': data,
          'Authorization': authHeader(),
          'Content-Type': 'application/json'
        },
      };

      axios.request(config)
        .then((response) => {
          if (response.data) {

            const res = JSON.parse(Crypter.decrypt(response.data));
            if (res.StatutCode == 200) {
              let datas = res.Result.Table[0];
              console.log(datas);

              if (res.Result.Table.length > 0) {
                props.form.setFieldValue('titre', datas.TITCLI);
                props.form.setFieldValue('lib_titre', datas.lib_TITCLI);
                props.form.setFieldValue('sexe', datas.CLSEXE);
                props.form.setFieldValue('nom', datas.NOMCLI);
                props.form.setFieldValue('prenom', datas.PRECLI);
                props.form.setFieldValue('dateNais', ReformatDate(datas.DATNAI));
                props.form.setFieldValue('lieuNais', datas.LIENAI);
                props.form.setFieldValue('cni', datas.numCNI);

                props.form.setFieldValue('datExpirCni', ReformatDate(datas.DateDelcni));
                props.form.setFieldValue('adresProcur', datas.NumDomCli);
                props.form.setFieldValue('TelProcur', datas.telCli);

              } else {
                SweetAlert.fire({ title: "Warning", text: "Client not found", icon: "warning" })
              }
            }
          }
        })
        .catch(function (error: any) {
          SweetAlert.fire({ text: error.message, icon: 'warning', confirmButtonText: 'OK' });

        })

    }
  }

  const ClientNotExist = () => {
    setidrelation(true);
    settitre(false);
    setsexe(false);
    setnomrel(false);
    setPrenom(false);
    setDateNaiss(false);
    setPieceIdebtite(false);
    setAdresse(false);
    setLieu(false);
    setExpire(false);
    setTel(false);
    props.form.setFieldValue('idrel', '');
    props.form.setFieldValue('lib_idrel', '');
    SetFormR(true);
    setReference(true)
  }

  const ClientExist = () => {
    settitre(true);
    setsexe(true);
    setnomrel(true);
    setPrenom(true);
    setDateNaiss(true);
    setPieceIdebtite(true);
    setAdresse(true);
    setLieu(true);
    setExpire(true);
    setTel(true);
    SetFormR(false);
    setReference(false);

  }

  //vérification de la d'entreée en vigeueur qui doit etre supérieur à la date actuelle
  const handleChangeDateETab = (e: any) => {
    const DatteActuel = new Date().toISOString();

    if (e.target.value > DatteActuel) {
      SweetAlert.fire({ title: "saisie invalide", text: "La date saisie est Supérieure à la Actuelle", icon: "error" });
      props.form.setFieldValue("datProcur", '');

    }
  };

  //vérification de la d'entreée en vigeueur qui doit etre supérieur à la date actuelle
  const handleChangeEnV = (e: any) => {
    const DatteActuel = new Date(user.datjour).toISOString();
    
    if (e.target.value < DatteActuel) {
      SweetAlert.fire({ title: "saisie invalide", text: "La date saisie est Supérieure à la Actuelle", icon: "error" });
      props.form.setFieldValue("datDebut", '');
    }
  };


  const handleChangeExpirele = (e: any) => {

    const dateD = props.form.getFieldValue("datProcur");
    //  alert(JSON.stringify(e.target.value + dateD));

    if (e.target.value <= dateD) {
      props.form.setFieldValue("DatExpirProcur", '');
      SweetAlert.fire({ title: "Saisie Invalide", text: " la date d'expiration doit de la procuration être supérieur à la date d'établissement ", icon: "error" });
    }

    if (dateD == '' || typeof dateD == 'undefined') {
      SweetAlert.fire({ title: "Warning", text: "la Veuillez Saisir la date d'expiration", icon: "warning" });
      props.form.setFieldValue("DatExpirProcur", '');
    }
  };

  const handleChangePrf = (e: any) => {
    const dateD = props.form.getFieldValue("datDebut");

    if (e.target.value < dateD) {
      SweetAlert.fire({ title: "Warning", text: "la date fin de la procuration doit être supérieur à la date d'entrée en vigueur", icon: "warning" });
      props.form.setField("DatFin",'');
    }
    if (dateD == '' || typeof dateD == 'undefined') {
      SweetAlert.fire({ title: "Warning", text: "la Veuillez Saisir la date d'entrée en vigueur", icon: "warning" });
      props.form.setFieldValue("DatFin", '');
    }

  };

  //vérification de la date de naissance qui doit etre supérieur à la date actuel
  const handleChangedatenais = (e: any) => {
    const DatteActuel = new Date().toISOString();

    if (e.target.value >= DatteActuel) {
      SweetAlert.fire({ title: "saisie invalide", text: "La date saisie est Supérieure à la Actuelle", icon: "error" });
      props.form.setFieldValue("dateNais", '');
    }

  };

  //vérification de la date d'expiration de la CNI qui doit etre supérieur à la date actuel
  const handleChangedateexpirecni = (e: any) => {
    const DatteActuel = new Date().toISOString();

    if (e.target.value <= DatteActuel) {
      SweetAlert.fire({ title: "saisie invalide", text: "La date saisie est Inférieure à la Actuelle", icon: "error" });
      props.form.setFieldValue("datExpirCni", '');
    }
  };


  const oncheck = (e: any) => {
    if (e == false) {
      ClientNotExist();
    }
    else if (e == true) {
      ClientExist();
    }
  }

  const onSelectChange = (newSelectedRowKeys: any) => {
    setSelectedRowKeys(newSelectedRowKeys);

    props.form.setFieldsValue(props.data[newSelectedRowKeys].RelObject);

    if (props.data[newSelectedRowKeys].RelObject.idrel === "" || props.data[newSelectedRowKeys].RelObject.idrel=== null) {
      props.form.setFieldValue('check', false);
      setReference(true);
    }
    else {
      setReference(false);
      props.form.setFieldValue('check', true);
    }
    
    props.form.setFieldValue('datExpirCni', ReformatDate(props.data[newSelectedRowKeys].RelObject.datExpirCni));
    props.form.setFieldValue('dateNais', ReformatDate(props.data[newSelectedRowKeys].RelObject.dateNais));
    props.form.setFieldValue('datProcur', ReformatDate(props.data[newSelectedRowKeys].RelObject.datProcur));
    props.form.setFieldValue('DatExpirProcur', ReformatDate(props.data[newSelectedRowKeys].RelObject.DatExpirProcur));
    props.form.setFieldValue('datDebut', ReformatDate(props.data[newSelectedRowKeys].RelObject.datDebut));
    props.form.setFieldValue('DatFin', ReformatDate(props.data[newSelectedRowKeys].RelObject.DatFin));
    props.form.setFieldValue('photo', props.data[newSelectedRowKeys].RelObject.photo);
    props.form.setFieldValue('signature', props.data[newSelectedRowKeys].RelObject.signature);
    props.form.setFieldValue('Piecej1', props.data[newSelectedRowKeys].RelObject.Piecej1);
    props.form.setFieldValue('Piecej2', props.data[newSelectedRowKeys].RelObject.Piecej2);
    props.form.setFieldValue('lib_Refprocur', props.data[newSelectedRowKeys].RelObject.nom);

    props.Consult();

  };

  const rowSelection =
  {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  return (
    <div className='tabItem' >
      <Box fontStyle="inherit" className='border-left border' width={"85%"} position={"absolute"}>
        <Box sx={{ width: '100%', p: 2 }}>
          
          {/* Section Identification Client */}
          <Card 
            title={
              <Box display="flex" alignItems="center" gap={1}>
                <UserOutlined style={{ color: '#116599' }} />
                <Typography variant="h6">Identification Client</Typography>
              </Box>
            } 
            style={{ marginBottom: 3 }}
            size="small"
          >
  
                <SearchInput 
                  notRequired 
                  dissabledCode={props.etatG} 
                  width={2} 
                  Titre={informationclient.SearchClient.Titre} 
                  label={informationclient.SearchClient.label} 
                  name={informationclient.SearchClient.name} 
                  Parametre={informationclient.SearchClient.params} 
                  form={props.form} 
                />
          </Card>

          {/* Section Information Procuration */}
          <Card 
            title={
              <Box display="flex" alignItems="center" gap={1}>
                <IdcardOutlined style={{ color: '#52c41a' }} />
                <Typography variant="h6">Information Procuration</Typography>
              </Box>
            } 
            style={{ marginBottom: 3 }}
            size="small"
          >
            <Row gutter={[8, 8]}>
              <Col span={12}>
                <Form.Item 
                  className='bordure'
                  labelCol={{ span: 6 }} 
                  name='check'
                  label='Client existant'
                  style={{ fontWeight: 600, marginBottom: 4 }}
                >
                  <Radio.Group
                    defaultValue={true}
                    onChange={e => {
                      setComponentDisabled(e.target.value);
                      oncheck(e.target.value);
                    }}
                  >
                    <Radio value={true}>OUI</Radio> <Radio value={false}>NON</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
              <Col span={12}>
                <SearInputM 
                  ExecuteafterSelect1={StartConsulte} 
                  notRequired 
                  disabled={Reference} 
                  width={4} 
                  name='idrel' 
                  Titre='Recherche procuration' 
                  label='Id mandataire' 
                  Parametre={searchClient2} 
                  form={props.form} 
                />
              </Col>
            </Row>
            <Row gutter={[8, 8]}>
              <Col span={12}>
                <SearInputM 
                  notRequired 
                  width={4} 
                  disabled={idrelation} 
                  Titre={informationclient.Searchrelation.Titre} 
                  label={informationclient.Searchrelation.label} 
                  name={informationclient.Searchrelation.name} 
                  Parametre={informationclient.Searchrelation.params} 
                  form={props.form} 
                />
              </Col>
              <Col span={12}>
                <SearInputM 
                  width={4} 
                  Titre={informationclient.SearchFiliation.Titre}
                  label={informationclient.SearchFiliation.label} 
                  name={informationclient.SearchFiliation.name}
                  Parametre={informationclient.SearchFiliation.params} 
                  form={props.form} 
                />
              </Col>
            </Row>
            <Row gutter={[8, 8]}>
              <Col span={12}>
                <InputForm 
                  icon={<MoneyCollectOutlined />} 
                  width={4} 
                  label={informationclient.Inputplafond.label} 
                  name={informationclient.Inputplafond.name} 
                  type='number' 
                />
              </Col>
            </Row>
          </Card>

          {/* Section Coordonnées et Informations Personnelles */}
          <Card 
            title={
              <Box display="flex" alignItems="center" gap={1}>
                <HomeOutlined style={{ color: '#fa8c16' }} />
                <Typography variant="h6">Coordonnées et Informations Personnelles</Typography>
              </Box>
            } 
            style={{ marginBottom: 1 }}
            size="small"
          >
            <Row gutter={[8, 8]}>
              {/* Colonne de gauche */}
              <Col span={12}>
                <InputForm 
                  width={4} 
                  disabled={nomrel} 
                  label={informationclient.InputNom.label} 
                  name={informationclient.InputNom.name} 
                  type='text' 
                />
                <InputForm 
                  disabled={Prenom} 
                  notRequired 
                  width={4} 
                  label={informationclient.InputPrenom.label} 
                  name={informationclient.InputPrenom.name} 
                  type='text' 
                />
                <SearInputM 
                  disabled={titre} 
                  notRequired 
                  width={4} 
                  Titre={informationclient.SearchTitre.Titre} 
                  label={informationclient.SearchTitre.label} 
                  name={informationclient.SearchTitre.name} 
                  Parametre={informationclient.SearchTitre.params} 
                  form={props.form} 
                />
                <RadioBox 
                  disabled={Sexe} 
                  width={4} 
                  label={informationclient.RadioSexe.label} 
                  name={informationclient.RadioSexe.name} 
                  Value1='M' 
                  Value2='F' 
                  LibValue1={informationclient.RadioSexe.LibValue1} 
                  libVlue2={informationclient.RadioSexe.LibValue2} 
                />
                <InputForm 
                  disabled={DateNaiss} 
                  width={4} 
                  onChange={handleChangedatenais} 
                  label={informationclient.InputDateNaiss.label} 
                  name={informationclient.InputDateNaiss.name} 
                  type='date' 
                />
              </Col>
              
              {/* Colonne de droite */}
              <Col span={12}>
                <InputForm 
                  disabled={Lieu} 
                  width={4} 
                  label={informationclient.InputLieu.label} 
                  name={informationclient.InputLieu.name} 
                  type='text' 
                />
                <InputForm 
                  disabled={PieceIdebtite} 
                  width={4} 
                  label={informationclient.InputPieceIdebtite.label} 
                  name={informationclient.InputPieceIdebtite.name} 
                  type='text' 
                />
                <InputForm 
                  disabled={Expire} 
                  onBlur={handleChangedateexpirecni} 
                  width={4} 
                  label={informationclient.InputExpire.label} 
                  name={informationclient.InputExpire.name} 
                  type='date' 
                />
                <InputForm 
                  notRequired 
                  disabled={Adresse} 
                  width={4} 
                  label={informationclient.InputAdresse.label} 
                  name={informationclient.InputAdresse.name} 
                  type='text' 
                />
                <InputForm 
                  icon={<PhoneOutlined />} 
                  disabled={Tel} 
                  width={4} 
                  label={informationclient.InputTel.label} 
                  name={informationclient.InputTel.name} 
                  type='text' 
                  RegExp={/[0-9]{9}$/gmi} 
                  MessExp='le numéro doit étre de 9 chiffres' 
                />
              </Col>
            </Row>
          </Card>

          {/* Section Détails de la Procuration */}
          <Card 
            title={
              <Box display="flex" alignItems="center" gap={1}>
                <CalendarOutlined style={{ color: '#eb2f96' }} />
                <Typography variant="h6">Détails de la Procuration</Typography>
              </Box>
            } 
            style={{ marginBottom: 0 }}
            size="small"
          >
            <Row gutter={[4, 4]}>
              <Col span={12}>
                <InputForm 
                  disabled={false} 
                  width={4} 
                  label={informationclient.InputAut.label} 
                  name={informationclient.InputAut.name} 
                  type='text' 
                />
                <InputForm 
                  disabled={false} 
                  width={4} 
                  label={informationclient.InputIdp.label} 
                  name={informationclient.InputIdp.name} 
                  type='text' 
                />
                <InputForm 
                  disabled={false} 
                  onChange={handleChangeDateETab} 
                  width={4} 
                  label={informationclient.InputEtabl.label} 
                  name={informationclient.InputEtabl.name} 
                  type='date' 
                />
              </Col>
              <Col span={12}>
                <InputForm 
                  disabled={false} 
                  width={4} 
                  label={informationclient.InputExpireP.label} 
                  onChange={handleChangeExpirele} 
                  name={informationclient.InputExpireP.name} 
                  type='date' 
                />
                <InputForm 
                  disabled={false} 
                  width={4} 
                  label={informationclient.InputEntrv.label} 
                  onChange={handleChangeEnV} 
                  name={informationclient.InputEntrv.name} 
                  type='date' 
                />
                <InputForm 
                  disabled={false} 
                  width={4} 
                  label={informationclient.InputPrf.label} 
                  onBlur={handleChangePrf} 
                  name={informationclient.InputPrf.name} 
                  type='date' 
                />
              </Col>
            </Row>
          </Card>

          {/* Section Documents */}
          <Card 
            title={
              <Box display="flex" alignItems="center" gap={1}>
                <PictureOutlined style={{ color: '#13c2c2' }} />
                <Typography variant="h6">Documents</Typography>
              </Box>
            }
            style={{ marginBottom: 1 }}
            size="small"
          >
            <Box display={'inline-flex'} marginTop='0'>
              <FormImage type='image' label='Photo' name='photo' nombre={1} form={props.form} required />
              <FormImage type='image' label='Signature' name='signature' nombre={1} form={props.form} required />
              <FormImage type='file' label='Piecej1' name='Piecej1' nombre={1} form={props.form} required />
              <FormImage type='file' label='Piecej2' name='Piecej2' nombre={1} form={props.form} />
            </Box>
          </Card>
            
            {/* Table de résultat */}
          <Box marginTop='0' >
            <Box display='flex' marginTop='0' >
              <Input.Search onChange={(e) => SetSearchR(e.target.value)} style={{ width: '100%' }} placeholder="Search here..." size="middle" />
            </Box>
            <Table
              sticky
              bordered
              size='small'
              rowSelection={{
                ...rowSelection,
                selectedRowKeys,
                type: 'radio',
                getCheckboxProps: (record) => ({ disabled: false }),
              }}
              style={{ width: '100%' }}
              columns={columns}
              dataSource={props.data}
              scroll={{ y: 150, x: 1000 }}
            />
          </Box>

          {/* Preview Modals */}
          <Modal 
            footer={false} 
            style={{ maxWidth: '800' }} 
            open={previewOpenM1} 
            title={previewTitle} 
            onCancel={() => setPreviewOpenM1(false)}
          >
            <img 
              alt="example" 
              style={{ width: '100%', maxHeight: 500 }} 
              src={previewImage} 
            />
          </Modal>
          <Dialog 
            open={previewOpen} 
            title={previewTitle}
          >
            <DialogTitle>Preview File</DialogTitle>
            <DialogContent>
              <embed 
                width="900" 
                height="500" 
                type="application/pdf" 
                src={previewImage} 
              />
            </DialogContent>
            <DialogActions>
              <Button 
                type='button' 
                onClick={() => setPreviewOpen(false)}
              >
                Fermer
              </Button>
            </DialogActions>
          </Dialog>
          
        </Box>
      </Box>
    </div>

  );
}


export default Tab1;
